export default __webpack_public_path__ + "static/media/hht2_ep5_speaking_01.e85b6565.png";